import { render, staticRenderFns } from "./StoreCleanEdu.vue?vue&type=template&id=0c431d82&scoped=true&"
import script from "./StoreCleanEdu.vue?vue&type=script&lang=js&"
export * from "./StoreCleanEdu.vue?vue&type=script&lang=js&"
import style0 from "./StoreCleanEdu.vue?vue&type=style&index=0&id=0c431d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c431d82",
  null
  
)

export default component.exports